import { Bot } from 'lucide-react'

import { SYMBOL_ONLY, SYMBOL_VIEWBOX } from '@/components/brand/Logo'
import { Button } from '@/components/ui/button'
import { useAgentConversations } from '@/hooks/useAgentConversation'
import { cn } from '@/lib/utils'
import { useInternalAgent } from './InternalAgentProvider'

/**
 * Comms-bar launcher for the internal agent: a robot on black, badged with the
 * Cai mark so it reads as our agent rather than as a generic bot.
 *
 * The amber dot means some chat of yours is blocked on a confirmation.
 */
export function InternalAgentBarButton() {
  const { open, toggle } = useInternalAgent()
  const { conversations } = useAgentConversations()
  const awaitingConfirmation = conversations.some((c) => c.isOwner && c.pendingConfirmation)

  const label = awaitingConfirmation ? 'Internal agent — action needs confirming' : 'Internal agent'

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggle}
      aria-label={label}
      aria-pressed={open}
      title={label}
      className={cn('relative size-11 border-none p-0', open && 'ring-primary ring-2')}
    >
      <span className="bg-ink relative flex size-8 items-center justify-center rounded-md">
        <Bot className="size-5 text-white" strokeWidth={2} />
        <span className="ring-surface absolute -right-1 -bottom-1 flex size-4 items-center justify-center rounded-full bg-white ring-2">
          <svg className="size-3" viewBox={SYMBOL_VIEWBOX} aria-hidden xmlns="http://www.w3.org/2000/svg">
            {SYMBOL_ONLY.map((d) => (
              <path key={d} d={d} fill="currentColor" />
            ))}
          </svg>
        </span>
      </span>
      {awaitingConfirmation && (
        <span className="absolute -top-1 -right-1 size-3 rounded-full bg-amber-500 ring-2 ring-white" />
      )}
    </Button>
  )
}
